import { Modal } from 'bootstrap';

$(document).ready(function () {
    if (typeof verzoegerung !== 'undefined') {
        window.setTimeout(function () {
            const stoerer = new Modal('#stoerer', {
                keyboard: false
            })
            stoerer.show();
        }, (verzoegerung * 1000)
        );
    }
});
